"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeTimeZone = exports.getLocalTime = exports.getUtcTime = void 0;
const constant_1 = require("../constants/constant");
const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(timezone);
function validateTime(value) {
    const dateFormatRegex = '[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]';
    const isCorrectFormat = value.match(dateFormatRegex);
    if (!isCorrectFormat) {
        throw new Error('Invalid date format');
    }
}
function getUtcTime(localTime, timeZone) {
    try {
        validateTime(localTime);
    }
    catch (error) {
        throw new Error(error.message);
    }
    return dayjs.tz(localTime, timeZone).utc().format(constant_1.defaultDateFormat);
}
exports.getUtcTime = getUtcTime;
const getLocalTime = (utcTime, timeZone) => {
    try {
        validateTime(utcTime);
    }
    catch (error) {
        throw new Error(error.message);
    }
    const utcTimeString = dayjs.tz(utcTime, 'UTC').toISOString();
    return dayjs(utcTimeString).tz(timeZone).format(constant_1.defaultDateFormat);
};
exports.getLocalTime = getLocalTime;
function changeTimeZone(utcTime, previousTimeZone, newTimeZone) {
    try {
        validateTime(utcTime);
    }
    catch (error) {
        throw new Error(error.message);
    }
    const previousLocalTime = dayjs.utc(utcTime).tz(previousTimeZone).format(constant_1.defaultDateFormat);
    return dayjs.tz(previousLocalTime, newTimeZone).utc().format(constant_1.defaultDateFormat);
}
exports.changeTimeZone = changeTimeZone;
